import "@arco-design/web-react/es/Grid/style";
import _Grid from "@arco-design/web-react/es/Grid";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Link/style";
import _Link from "@arco-design/web-react/es/Link";
import "@arco-design/web-react/es/Checkbox/style";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconEmail from "@arco-design/web-react/icon/react-icon/IconEmail";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Tabs/style";
import _Tabs from "@arco-design/web-react/es/Tabs";
import React, { useEffect, useRef, useState } from 'react';
import api from '@/utils/api';
import useStorage from '@/utils/useStorage';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
const TabPane = _Tabs.TabPane;
export default function LoginForm() {
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showResendButton, setShowResendButton] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [emailForResend, setEmailForResend] = useState('');
  const [loginParams, setLoginParams, removeLoginParams] = useStorage('loginParams');
  const [loginType, setLoginType] = useState('password');
  const [otpSending, setOtpSending] = useState(false);
  const [otpCountdown, setOtpCountdown] = useState(0);
  const t = useLocale(locale);
  const [rememberPassword, setRememberPassword] = useState(!!loginParams);

  // 倒计时效果
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  // 验证码倒计时效果
  useEffect(() => {
    let timer;
    if (otpCountdown > 0) {
      timer = setTimeout(() => setOtpCountdown(otpCountdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [otpCountdown]);
  function afterLoginSuccess(params, token, companies, currentCompany) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    }
    // 存储令牌
    localStorage.setItem('token', token);
    // 存储公司列表和当前公司
    if (companies && companies.length > 0) {
      localStorage.setItem('companies', JSON.stringify(companies));
    }
    if (currentCompany) {
      localStorage.setItem('current_company_id', currentCompany.id.toString());
      localStorage.setItem('currentCompany', JSON.stringify(currentCompany));
    }
    // 跳转首页
    window.location.href = '/';
  }
  function login(params) {
    setErrorMessage('');
    setShowResendButton(false);
    setLoading(true);

    // 根据登录类型选择不同的API端点
    const endpoint = loginType === 'password' ? '/api/login' : '/api/auth/otp/login';
    api.post(endpoint, params).then(res => {
      const {
        data
      } = res;
      // 现在 res 就是后端返回的完整数据结构 { code, message, data }
      if (data.code === 200 && data.data?.access_token) {
        afterLoginSuccess(params, data.data.access_token, data.data.companies, data.data.current_company);
      } else {
        // console.log(data);
        setErrorMessage(data.message || t['login.form.login.errMsg']);

        // 如果是邮箱未验证错误，显示重新发送按钮
        if (data.code === 203) {
          setShowResendButton(true);
          setEmailForResend(params.email);
          setCountdown(60); // 设置60秒倒计时
        }
      }
    }).catch(error => {
      // console.log(error);
      // 从错误对象中提取消息
      const errorMessage = error?.response?.data?.message || error.message || t['login.form.login.errMsg'];
      setErrorMessage(errorMessage);

      // 检查是否是邮箱未验证错误
      if (error?.response?.data?.code === 203) {
        setShowResendButton(true);
        setEmailForResend(params.email);
        setCountdown(60); // 设置60秒倒计时
      }
    }).finally(() => {
      setLoading(false);
    });
  }

  // 重新发送验证邮件
  function resendVerificationEmail() {
    if (countdown > 0) return; // 如果还在倒计时中，不执行操作

    setResendLoading(true);
    api.post('/api/email/resend', {
      email: emailForResend
    }).then(res => {
      const {
        data
      } = res;
      if (data.code === 200) {
        setErrorMessage('验证邮件已发送，请检查您的邮箱');
        setCountdown(60); // 重新开始60秒倒计时
      } else {
        setErrorMessage(data.message || '发送失败，请稍后重试');
      }
    }).catch(error => {
      // console.log(error);
      setErrorMessage('发送失败，请稍后重试');
    }).finally(() => {
      setResendLoading(false);
    });
  }

  // 发送验证码
  function sendOtp() {
    if (otpCountdown > 0) return; // 如果还在倒计时中，不执行操作

    // 验证邮箱是否已填写
    const email = formRef.current.getFieldValue('email');
    if (!email) {
      setErrorMessage(t['login.form.email.errMsg']);
      return;
    }
    setOtpSending(true);
    api.post('/api/auth/otp/send', {
      email
    }).then(res => {
      const {
        data
      } = res;
      if (data.code === 200) {
        _Message.success(t['login.form.otp.send.success']);
        setOtpCountdown(120); // 设置2分钟倒计时
      } else {
        setErrorMessage(data.message || t['login.form.otp.send.fail']);
      }
    }).catch(error => {
      // console.log(error);
      setErrorMessage(error?.response?.data?.message || t['login.form.otp.send.fail']);
    }).finally(() => {
      setOtpSending(false);
    });
  }
  function onSubmitClick() {
    formRef.current.validate().then(values => {
      login(values);
    }).catch(error => {
      // 处理表单验证错误
      // console.log('表单验证失败:', error);
      // 可以选择显示具体的验证错误信息
      if (error.errors) {
        // 显示第一个验证错误信息
        setErrorMessage(t['login.form.login.errMsg']);
      } else {
        setErrorMessage(t['login.form.login.errMsg']);
      }
    });
  }

  // 读取 localStorage，设置初始值
  useEffect(() => {
    const rememberPassword = !!loginParams;
    setRememberPassword(rememberPassword);
    if (formRef.current && rememberPassword) {
      const parseParams = JSON.parse(loginParams);
      formRef.current.setFieldsValue(parseParams);
    }
  }, [loginParams]);

  // 检查URL参数，处理邮箱验证成功后的登录
  useEffect(() => {
    // 解析URL参数
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (token) {
      // 如果URL中有token参数，直接登录
      afterLoginSuccess({}, token);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    },
    className: styles['login-form-title']
  }, t['login.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-error-msg']
  }, errorMessage), showResendButton && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: resendVerificationEmail,
    loading: resendLoading,
    disabled: countdown > 0
  }, countdown > 0 ? t['login.email.resend'] + ` (${countdown}s)` : t['login.email.resend'])), /*#__PURE__*/React.createElement(_Tabs, {
    activeTab: loginType,
    onChange: key => setLoginType(key),
    type: "rounded"
  }, /*#__PURE__*/React.createElement(TabPane, {
    key: "password",
    title: t['login.form.switchToPassword']
  }, /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "email",
    rules: [{
      required: true,
      message: t['login.form.email.errMsg']
    }, {
      type: 'email',
      message: t['login.form.email.formatErrMsg']
    } // 添加邮箱格式验证
    ]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconEmail, null) // 更换为邮箱图标
    ,
    placeholder: t['login.form.email.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    rules: [{
      required: true,
      message: t['login.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['login.form.password.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-password-actions']
  }, /*#__PURE__*/React.createElement(_Checkbox, {
    checked: rememberPassword,
    onChange: setRememberPassword
  }, t['login.form.rememberPassword']), /*#__PURE__*/React.createElement(_Link, {
    onClick: () => window.location.href = '/reset-password'
  }, t['login.form.forgetPassword'])), /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['login.form.login']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    className: styles['login-form-register-btn'],
    onClick: () => window.location.href = '/register'
  }, t['login.form.register']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    onClick: () => setLoginType('otp')
  }, t['login.form.switchToOtp'])))), /*#__PURE__*/React.createElement(TabPane, {
    key: "otp",
    title: t['login.form.switchToOtp']
  }, /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "email",
    rules: [{
      required: true,
      message: t['login.form.email.errMsg']
    }, {
      type: 'email',
      message: t['login.form.email.formatErrMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconEmail, null),
    placeholder: t['login.form.email.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, null, /*#__PURE__*/React.createElement(_Grid.Row, {
    gutter: 0
  }, /*#__PURE__*/React.createElement(_Grid.Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "otp",
    rules: [{
      required: true,
      message: t['login.form.otp.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['login.form.otp.placeholder'],
    maxLength: 6,
    onPressEnter: onSubmitClick
  }))), /*#__PURE__*/React.createElement(_Grid.Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(_Form.Item, null, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    size: "default",
    onClick: sendOtp,
    loading: otpSending,
    disabled: otpCountdown > 0,
    style: {
      width: '100%'
    }
  }, otpCountdown > 0 ? `${t['login.form.otp.send.again']} (${otpCountdown}s)` : t['login.form.otp.send']))))), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['login.form.login']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    className: styles['login-form-register-btn'],
    onClick: () => window.location.href = '/register'
  }, t['login.form.register']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    onClick: () => setLoginType('password')
  }, t['login.form.switchToPassword']))))));
}